"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
const SessionServiceLive_1 = require("./SessionServiceLive");
class SessionService {
    static create() {
        return new SessionServiceLive_1.SessionServiceLive();
    }
}
exports.SessionService = SessionService;
//# sourceMappingURL=SessionService.js.map